<template>
  <div>
    <b-container>
      <b-row align-v="center">
        <b-col lg="3">
          <h2 class="h3-semibold-black">Sei già nostro cliente?</h2>
          <p class="p-medium-gray-600 mb-4">Se scegli Sì, per procedere ti verrà richiesto il tuo Codice Cliente ASTEA. Non lo sei? Nessun problema, conosciamoci!</p>
        </b-col>
        <b-col lg="6" class="lg:px-6">
          <b-row>
            <b-col cols="6">
              <div class="config-button-element" :class="{isActive:clienteSiNo}" @click="setClienteSiNo(true)">
                <span>Si</span>
              </div>
            </b-col>
            <b-col cols="6">
              <div class="config-button-element" :class="{isActive:clienteSiNo===false}" @click="setClienteSiNo(false)">
                <span>No</span>
              </div>
            </b-col>
          </b-row>
        </b-col>

        <b-col lg="3" class="text-center lg:text-right image-col">
          <div class="icon mb-8 mt-5 lg:mt-0 px-4 lg:px-0">
          </div>
        </b-col>
      </b-row>
    </b-container>

    <footer-nav-component :disabled-next="clienteSiNo == null" @prev="goPrev" @next="goNext"></footer-nav-component>
  </div>
</template>

<script>
import FooterNavComponent from "@/components/FooterNavComponent";

export default {
  name: 'StepSeiCliente',
  components: {FooterNavComponent},
  data() {
    return {
      localOptions: null,
      webPath: process.env.VUE_APP_WEB_PATH,
      clienteSiNo: null
    }
  },
  props: {
    options: {
      type: [Array, Object],
      required: true
    }
  },
  created() {
    this.localOptions = this._.cloneDeep(this.options);

    if (typeof this.localOptions.comune == 'undefined' || this.localOptions.comune == null)
      this.$router.push({name: 'step-comune'})

    if(typeof window.fbq != 'undefined') {
      this.trackFbViewContent('configuratore_serena', 'step-sei-cliente');
    }
  },
  methods: {
    setClienteSiNo(val) {
      this.clienteSiNo = val;
      this.goNext();
    },
    goPrev() {
      this.$router.push({name: 'step-comune'})
    },
    goNext() {
      let newOptions = {
        comune: this.localOptions.comune,
        seiCliente: this.clienteSiNo,
        cliente: null,
        forniture: null,
        consumo: null,
        rate: null,
      };
      this.$emit('updateOptions', newOptions);

      if (this.clienteSiNo) this.$router.push({name: 'step-si-cliente'})
      else this.$router.push({name: 'step-no-tipo-fornitura'})
    }
  },
}
</script>

<style scoped lang="scss">
</style>